import support from '../../services/support'
import { i18n } from '../../main'
import moment from "moment"
const packageVersion =  window.configs && window.configs.PACKAGE_VERSION !== "" 
? window.configs.PACKAGE_VERSION: process.env.PACKAGE_VERSION;
function initState() {
  let title = ''
  let body = ''
  let reasons = [{ label: 'Aucune raison', value: 'Aucune raison' }]
  let recipients = []
  return {
    title,
    body,
    reasons,
    recipients,
    packageVersion: packageVersion || '0'
  }
}

function fillTitle(template, payload) {
  const {
    firstName,
    name,
    reason,
    title
  } = payload
  return (
    template
      .replace('[user:name]', `${firstName} ${name}`)
      .replace('[input:reason]', reason)
      .replace('[input:title]', title)
  )
}

function fillBody(template, payload) {
  const {
    firstName,
    name,
    email,
    reason,
    title,
    messages,
    versionApp,
    agencyName,
    device,
    browser,
    pkAdv,
    pointings
  } = payload
  const formatMsg = `<div style='white-space:pre;overflow-wrap:break-word;word-break:break-word;'>${messages}</div>`
  return (
    template
      .replace('[user:name]', `${firstName} ${name}`)
      .replace('[user:email]', email)
      .replace('[input:reason]', reason)
      .replace('[Input title from the user]', title)
      .replace('[Input messages from the user]', formatMsg)
      .replace('[VersionApp]', versionApp)
      .replace('[VersionOS]', browser)
      .replace('[Model]', device)
      .replace('Version de l\'application', 'Version de site')
      .replace('Modèle de téléphone', 'Modèle de ordinateur')
      .replace('Version de l\'OS', 'Version de navigateur')
      .replace('[AgencyName]', agencyName ? `Vitalliance ${agencyName}` : '')
      .replace('[PKNagora]', pkAdv)
      .replace('[pointings]', showPointings(pointings) || '')
  )
}

function showPointings(pointings) {
  if (pointings.length) {
    const histories = []
    pointings.forEach(element => {
      const typePointage = element.typePointage === 1 ? i18n.t('pointing-history-view-begin-label') : i18n.t('pointing-history-view-end-label')
      const pointing = `<div style='display: flex'><p style='width:15%; margin: 0px 0px 0px 20px'>${typePointage}</p><p style='width:45%; margin: 0px 10px'>${element.clientName}</p><p style='width:40%; margin: 0px'>${moment(element.horodatage).format('DD / MM / YYYY – HH:mm')}</p></div>`
      histories.push(pointing)
    });
    return histories.join('')
  // } else {
  //   const noData = i18n.t('no-data')
  //   return `<span>${noData}</span>`
  }
}

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    SET_TITLE(state, title) {
      state.title = title
    },
    SET_BODY(state, body) {
      state.body = body
    },
    SET_REASONS(state, reasons) {
      const reworkReasons = reasons.map(r => {
        return {
          id: r.id,
          value: r.text,
          text: r.text
        }
      })
      state.reasons = reworkReasons
    },
    SET_RECIPIENTS(state, recipients) {
      const reworkRecipients = recipients.map(r => {
        return {
          value: r.emailAddress,
          text: r.emailAddress
        }
      })
      state.recipients = reworkRecipients
    }
  },
  actions: {
    async init(store) {
      const tsClaime = await support
        .get('hr')
        .catch(
          () => undefined
        )
      if (tsClaime) {
        store.commit('SET_TITLE', tsClaime.title)
        store.commit('SET_BODY', tsClaime.content)
        store.commit('SET_REASONS', tsClaime.reasons)
        store.commit('SET_RECIPIENTS', tsClaime.recipient)
      }
    },
    async send(store, payload) {
      const reason = store.getters.reasons.find(r => r.value === payload.reason)
      const body = {
        title: payload.title,
        content: payload.messages,
        isAgencyInformed: payload.agencyInformed,
        idClaimReason: reason ? reason.id : payload.reason
      };
      return new Promise((resolve, reject) => {
        support.claim(body, 'hr').then(res => {
          res.success ? resolve(res) : reject(false);
        }).catch(err => {
          reject(err);
        })
      });
    }
  },
  getters: {
    title: state => state.title,
    body: state => state.body,
    reasons: state => state.reasons,
    recipients: state => state.recipients,
    appVersion: state => state.packageVersion
  }
}
